
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcMessageMenuItem as ObcMessageMenuItemElement} from '@oicl/openbridge-webcomponents/dist/components/message-menu-item/message-menu-item.js';
 
 
 

 
 export const ObcMessageMenuItem = createComponent({
   react: React,
   tagName: 'obc-message-menu-item',
   elementClass: ObcMessageMenuItemElement,
   events: {
     
     onMessageClick: 'message-click' as EventName<CustomEvent<{open: boolean}>>,
     onPrimaryActionClick: 'primary-action-click' as EventName<CustomEvent<void>>,
     onSecondaryActionClick: 'secondary-action-click' as EventName<CustomEvent<void>>,
   }
  });
 
 